export default __webpack_public_path__ + "static/media/typescript.b6a67c48.svg";